module.exports = __webpack_public_path__ + "img/slider.2d5fdac4.svg";